<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ResourceIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resource/Index.vue